app.controller("DocumentTypesAddAddController", [
    "$scope", "$uibModalInstance", "params", "StaticData", "DocumentsService", "OrganizationalUnit", "toastr", "$timeout",
    function ($scope, $uibModalInstance, params, StaticData, DocumentsService, OrganizationalUnit, toastr, $timeout) {
        $scope.docType = params.docType;
        $scope.action = 'დამატება';
        $scope.types = [];
        $scope.actions = [];
        $scope.actionsMap = [];
        $scope.endpoints = [
            { name: 'კანცელარია', value: 'chancellery', order: 1 },
            { name: 'სამსახურის უფროსი', value: 'headRevision', order: 2 },
            { name: 'კანცლერი', value: 'chancellorPermission', order: 3 }
        ];

        $scope.disabledOptions = [
            { _id: "false", name: 'კი' },
            { _id: 'true', name: 'არა' }
        ]
        $scope.tinymceOptions = {
            menubar: '',
            toolbar: 'undo redo | underline bold italic | alignleft aligncenter alignright',
            height: "400"
        };

        if ($scope.docType)
            $scope.docType.disabled = ($scope.docType.disabled || false).toString()

        if (params.docType && params.docType.defaultAddresseeUnit) {
            OrganizationalUnit.getById(params.docType.defaultAddresseeUnit).then(function (data) {
                $scope.docType.defaultAddresseeUnitObj = data;
            });
        }

        // $scope.endpoints = _.sortBy($scope.endpoints, function (el) {
        //     console.log(el)
        //     console.log(params)
        //     return params.docType.motion[el.value].priority;
        // });

        StaticData.getItemsByKey("document_basic_types").then(function (types) {
            $scope.types = types;
            $scope.typesMap = _.keyBy($scope.types, '_id');
        });

        StaticData.getItemsByKey("document_type_actions").then(function (actions) {
            $scope.actions = actions;
            $scope.actionsMap = _.keyBy($scope.actions, '_id');
            if (params.action === 'edit') {
                $scope.action = 'რედაქტირება';
                for (var i in $scope.docType.actions) {
                    $scope.actionsMap[$scope.docType.actions[i]] = true
                }
            }
        });

        $scope.treeOptions = {
            dragStop: function () {
                $timeout(function () {
                    $scope.endpoints.forEach(function (el, index) {
                        params.docType.motion[el.value].priority = index + 1;
                    });
                }, 0);
            }
        };

        $scope.save = function () {
            // if (!$scope.docType.defaultAddresseeUnitObj) return; //ეს რატო გვეწერა არ ვერ მივხვდი. არაა აუცილებელი დეფოლთ მიმღები ყავდეს ყველა ტიპს...
            if (!$scope.docType.parentId) return;

            var saveFunction = null;
            if (params.action === 'add') saveFunction = DocumentsService.addDocType;
            if (params.action === 'edit') saveFunction = DocumentsService.editDocType;


            $scope.docType.actions = [];
            for (var i in $scope.actionsMap) {
                if ($scope.actionsMap[i]) $scope.docType.actions.push(i)
            }

            if ($scope.docType.defaultAddresseeUnitObj)
                $scope.docType.defaultAddresseeUnit = $scope.docType.defaultAddresseeUnitObj._id;

            if ($scope.docType.parentId == 'STUDENT_INNER') {
                $scope.docType.isForStudent = true;
            }

            //ეს აღარ გვინდა რადგან , უკვე შესაძლებელია ორივე ერთდროულად იყოს მონიშნული
            // if ($scope.docType.isForFaculty) {
            //     $scope.docType.defaultAddresseeUnit = null;
            // }

            saveFunction($scope.docType).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status === 400) {
                    toastr.error('', 'დაფიქსირდა შეცდომა.');
                }
            });
        };

        $scope.select = function (point, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $scope.docType.motion[point.value].state = !$scope.docType.motion[point.value].state;
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };



        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({ query: query }).then(function (data) {
                return data;
            });
        };

        $scope.showTooltip = ($scope.docType.parentId == 'INNER' && $scope.docType.isForStudent && ($scope.docType.isForStudent || $scope.docType.parentId == 'STUDENT_INNER'));
        $scope.tooltipText = 'ორივე ველის მითითების შემთხვევაში, წერილი კანცელარიის გავლით დაეწერება ორივე სამსახურს, სხვა შემთხვევაში მხოლოდ მითითებულ სამსახურს.'
    }
]);
